import { c as _c } from "react/compiler-runtime";
import { LeadCreationResponse } from "@justhome/api-core";
import { LEAD_ID_PARAMETER } from "@justhome/common/constants";
import useLanguage from "@lib/hooks/useLanguage";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import EmbeddedFormScreen from "@modules/application/components/EmbeddedFormScreen";
import { FormState } from "@modules/application/context/ApplicationContext";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import useSteps from "@modules/application/hooks/useSteps";
import getBudgetCheckSteps from "@modules/application/lib/budgetCheck";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { useTranslation } from "next-i18next";
import { useRouter } from "@lib/hooks/useRouter";
import { FC, useEffect, useMemo, useRef, useState } from "react";
export const EmbeddedBudgetCheck: FC = () => {
  const $ = _c(27);
  const {
    t
  } = useTranslation("budget-check");
  const {
    partner
  } = usePartnerContext();
  const locale = useLanguage();
  const ref = useRef(null);
  const router = useRouter();
  const queryLeadId = router.query[LEAD_ID_PARAMETER] as string;
  const {
    dispatch
  } = useApplicationContext();
  const t0 = !!queryLeadId;
  const t1 = partner?.slug;
  let t2;
  if ($[0] !== locale || $[1] !== t || $[2] !== t0 || $[3] !== t1) {
    t2 = getBudgetCheckSteps(t, locale, true, t0, t1, false);
    $[0] = locale;
    $[1] = t;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const steps = t2;
  const [stepId, setStepId] = useState(steps[0].id);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      values: {},
      history: []
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [state, setState] = useState(t3);
  let t4;
  let t5;
  if ($[6] !== dispatch || $[7] !== queryLeadId) {
    t4 = () => {
      if (queryLeadId) {
        dispatch({
          type: "SET_LEAD",
          lead: {
            id: queryLeadId
          } as LeadCreationResponse
        });
      }
    };
    t5 = [dispatch, queryLeadId];
    $[6] = dispatch;
    $[7] = queryLeadId;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== router || $[11] !== state || $[12] !== stepId || $[13] !== steps) {
    t6 = {
      stepId,
      steps,
      formState: state,
      hasZeroStep: false,
      onInvalidState() {
        if (steps[0]) {
          setStepId(steps[0].id);
        }
      },
      onSetForm(form) {
        setState(form);
      },
      onStepChange(step) {
        setStepId(step.id);
      },
      onGoBack() {
        const previous = state.history.at(-1);
        if (previous) {
          setStepId(previous);
          setState({
            ...state,
            history: state.history.slice(0, -1)
          });
        }
      },
      onComplete(step_0) {
        if (step_0.navigateTo) {
          router.push(step_0.navigateTo);
        }
      }
    };
    $[10] = router;
    $[11] = state;
    $[12] = stepId;
    $[13] = steps;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const formSteps = useSteps(t6);
  let t7;
  let t8;
  if ($[15] !== formSteps.currentStepNumber) {
    t7 = () => {
      if (formSteps.currentStepNumber) {
        ref.current?.scrollIntoView({
          behavior: "smooth"
        });
      }
    };
    t8 = [formSteps.currentStepNumber];
    $[15] = formSteps.currentStepNumber;
    $[16] = t7;
    $[17] = t8;
  } else {
    t7 = $[16];
    t8 = $[17];
  }
  useEffect(t7, t8);
  const Component = formSteps.currentStep.component || EmbeddedFormScreen;
  let t9;
  if ($[18] !== Component || $[19] !== formSteps.currentStep || $[20] !== formSteps.currentStepNumber || $[21] !== formSteps.handleNextStep || $[22] !== formSteps.handlePreviousStep || $[23] !== formSteps.nextSteps || $[24] !== formSteps.numberOfSteps || $[25] !== formSteps.value) {
    t9 = <div ref={ref} className="scroll-m-[148px] m:scroll-m-5xl"><Component steps={formSteps.nextSteps} onPrevious={formSteps.handlePreviousStep} onNext={formSteps.handleNextStep} numberOfSteps={formSteps.numberOfSteps} hasZeroStep={false} currentStepNumber={formSteps.currentStepNumber} step={formSteps.currentStep} value={formSteps.value} /></div>;
    $[18] = Component;
    $[19] = formSteps.currentStep;
    $[20] = formSteps.currentStepNumber;
    $[21] = formSteps.handleNextStep;
    $[22] = formSteps.handlePreviousStep;
    $[23] = formSteps.nextSteps;
    $[24] = formSteps.numberOfSteps;
    $[25] = formSteps.value;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default EmbeddedBudgetCheck;